import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
interface IProps {
  moduleData: any;
  updateModuleData: any;
  handleDelete: any;
  department: any;
  id: any;
}

const TController = ({
  handleDelete,
  moduleData,
  updateModuleData,
  department,
  id,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead {...{ moduleData, updateModuleData, department }} />
        <TBody
          {...{
            handleDelete,
            moduleData,
            updateModuleData,
            id,
          }}
        />
        <TFoot
          {...{
            moduleData,
            updateModuleData,
          }}
        />
      </RenderTable>
    </Box>
  );
};

export default TController;
